import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NewsletterSignup from "@/components/NewsletterSignup";

const STORAGE_KEY = "folio_subscribed";

export default function Subscribe() {
  const [alreadySubbed, setAlreadySubbed] = useState(false);
  const [resubscribing, setResubscribing] = useState(false);

  useEffect(() => {
    setAlreadySubbed(localStorage.getItem(STORAGE_KEY) === "true");
  }, []);

  const updatePreferences = () => {
    // Clear the local flag so the form goes back to step 1 and re-posts
    localStorage.removeItem(STORAGE_KEY);
    setAlreadySubbed(false);
    setResubscribing(true);
  };

  return (
    <div data-testid="subscribe-page" className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="label-eyebrow text-sage mb-3">Folio · Subscribe</div>
      <h1 className="font-serif text-5xl sm:text-6xl tracking-tight max-w-3xl">
        Quiet letters, every now and then.
      </h1>
      <p className="text-muted_ink mt-6 max-w-2xl text-lg leading-relaxed">
        Subscribe for new releases, exclusive discount codes for subscribers only, and curated lists from the editors.
        No more than one or two emails a month — and you can leave whenever you want.
      </p>

      <div className="mt-12">
        {alreadySubbed && !resubscribing ? (
          <div data-testid="already-subscribed" className="border border-edge bg-linen p-10">
            <div className="label-eyebrow text-sage">You're on the list.</div>
            <div className="font-serif text-3xl mt-3">Manage your preferences.</div>
            <p className="text-muted_ink mt-3 max-w-lg text-sm">
              Want to update your name or favorite categories? Or unsubscribe altogether?
              Use the "Update preferences" button to re-open the signup form (posting the same
              email will refresh your details), or use the unsubscribe link from any Folio email.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                data-testid="manage-preferences-btn"
                onClick={updatePreferences}
                className="btn-primary"
              >
                Update preferences
              </button>
              <Link to="/browse" className="btn-secondary">Back to the shelf</Link>
            </div>
          </div>
        ) : (
          <NewsletterSignup variant="hero" />
        )}
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {[
          { t: "New releases", d: "First word when a new title lands on the shelf." },
          { t: "Subscriber discounts", d: "Quiet codes we only share by email." },
          { t: "Editor's notes", d: "Short essays, reading lists, and recommendations." },
        ].map((b) => (
          <div key={b.t} className="border-t border-edge pt-5">
            <div className="font-serif text-2xl">{b.t}</div>
            <p className="text-muted_ink mt-2 text-sm">{b.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
